import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../../Widget'
import { useListingProfileContext } from '../../RentalPortalListingProfile.hooks'
import { getListingProfileWidgetActionsProps } from '../../RentalPortalListingProfile.utils'

import { QA_NAME_LISTING_PROFILE_DESCRIPTION_WIDGET } from './RentalPortalListingProfileDescriptionWidget.constants'
import { RentalPortalListingProfileDescriptionWidgetContent } from './RentalPortalListingProfileDescriptionWidgetContent'

function RentalPortalListingProfileDescriptionWidget() {
  const { t } = useTranslation()

  const { isInitiated, isPreview, listingData } = useListingProfileContext()

  const containerRef = useRef(null)

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: getListingProfileWidgetActionsProps({
            isPreview,
            listingData,
          }),
        },
      }}
      isSkeleton={!isInitiated || !listingData}
      qaName={QA_NAME_LISTING_PROFILE_DESCRIPTION_WIDGET}
      ref={containerRef}
      title={t('RentalPortal.ListingProfileDescriptionTitleKey')}
    >
      <RentalPortalListingProfileDescriptionWidgetContent
        containerRef={containerRef}
      />
    </Widget>
  )
}

export default RentalPortalListingProfileDescriptionWidget
